module.exports = __webpack_public_path__ + "img/ceshi7.3fa9b1ad.png";